import { AI } from 'blaze-ui/icons'
import { FloatingButton } from 'blaze-ui/FloatingButton/FloatingButton'
import { useHistory } from 'react-router-dom'
import { useArticleViewLink } from 'hooks/useArticleViewLink'
import { ArticleView } from 'types'
import { AIMenuDrawer } from 'common/Prose/Toolbar/MobileWriterToolbar/AIMenuDrawer'
import { DrawersStore } from 'stores/DrawersStore'

export const AIButton = ({ drawersStore }: { drawersStore: DrawersStore }) => {
  const { to } = useArticleViewLink({ articleView: ArticleView.Editing })
  const history = useHistory()
  const openDrawer = () => {
    history.replace({
      pathname: to.pathname,
      search: to.search,
    })

    drawersStore.openDrawer(AIMenuDrawer)
  }

  return <FloatingButton offset={64} icon={AI} onPress={openDrawer} variant="secondary" />
}
